import script from "./pSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./pSelect.vue?vue&type=script&setup=true&lang=ts"

import "./pSelect.vue?vue&type=style&index=0&id=bceabce4&lang=css"

const __exports__ = script;

export default __exports__